<button [ngClass]="[
    'font-sans flex min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-10 px-4 text-sm font-medium leading-normal',
    fullWidth ? 'w-full' : '',
    disabled ? 'opacity-50 cursor-not-allowed' : '',
    priority === 'high' ? 'ring-2 ring-offset-2 ring-blue-500' :
    priority === 'low' ? 'opacity-80' : '',
    variant === 'primary' ? 'bg-metro-blue text-metro-secondary' : '',
    variant === 'secondary' ? 'bg-metro-secondary text-metro-black' : '',
    variant === 'danger' ? 'bg-red-500 text-white' : '',
    variant === 'custom' ? customClass : '',
    size === 'sm' ? 'h-8 text-sm' : '',
    size === 'md' ? 'h-10 text-base' : '',
    size === 'lg' ? 'h-12 text-lg' : ''
  ]" [disabled]="disabled" [type]="type" (click)="onClick()">

  @if (loading) {
  <svg class="animate-spin h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
  </svg>
  } @else {
    @if (icon && iconPosition === 'left') {
    <app-metro-icon [svg]="icon" [size]="iconSize" [color]="iconColor" class="mr-2"></app-metro-icon>
    }
    
    <span class="truncate">{{ text }}</span>

    @if (icon && iconPosition === 'right') {
    <app-metro-icon [svg]="icon" [size]="iconSize" [color]="iconColor" class="ml-2"></app-metro-icon>
    }
  }
</button>